import { call, put } from "redux-saga/effects";
import BusinessActions from "./business-actions";
import * as api from "../../services/api";
import {
  hasReportConfigurationXlsxPayload,
  normalizeReportConfigurations,
  resolveReportDownloadFilename,
  parseReportGenerateError,
  triggerReportConfigurationXlsxDownload,
} from "../../constants/reportConfiguration";

export function* getBusiness(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getBusiness, businessId);

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessSuccess(response.data));
  } else {
    yield put(BusinessActions.businessFailure(response.data));
  }
}

export function* getBusinessesByName(action) {
  const { nameQuery, options } = action;
  // make the call to the api
  const response = yield call(api.getBusinessesByName, nameQuery, options);

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessesByNameSuccess(response.data));
  } else {
    yield put(BusinessActions.businessesByNameFailure(response.data));
  }
}

export function* getBusinessesByNameCount(action) {
  const response = yield call(api.getBusinessesByNameCount, action.nameQuery);

  if (response.ok) {
    yield put(BusinessActions.businessesByNameCountSuccess(response.data));
  } else {
    yield put(BusinessActions.businessesByNameCountFailure(response.data));
  }
}

export function* getBusinesses(action) {
  const { options } = action;
  // make the call to the api
  const response = yield call(api.getBusinesses, options);

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessAllSuccess(response.data));
  } else {
    yield put(BusinessActions.businessAllFailure(response.data));
  }
}

export function* getBusinessesCount() {
  // make the call to the api
  const response = yield call(api.getBusinessesCount);

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessesCountSuccess(response.data));
  } else {
    yield put(BusinessActions.businessesCountFailure(response.data));
  }
}

export function* updateBusiness(action) {
  const { business } = action;
  // make the call to the api
  const idIsNotNull = !!business.id;
  const response = yield call(
    idIsNotNull ? api.updateBusiness : api.createBusiness,
    business
  );

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessUpdateSuccess(response.data));
  } else {
    yield put(BusinessActions.businessUpdateFailure(response.data));
  }
}

export function* deleteBusiness(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.deleteBusiness, businessId);

  // success?
  if (response.ok) {
    yield put(BusinessActions.businessDeleteSuccess());
  } else {
    yield put(BusinessActions.businessDeleteFailure(response.data));
  }
}

export function* cacheBusinessesList(action) {
  // success ?
  const response = yield call(api.getCachedBusinesses)
  if (response.ok) {
    yield put(BusinessActions.cacheBusinessesSuccess(response.data));
  } else {
    yield put(BusinessActions.cacheBusinessesFailure(response.data));
  }
}

export function* enterpriseCustomersList(action) {
  const { businessId, options } = action
  // if success
  const response = yield call(api.getEnterpriseCustomers, businessId, options)
  if (response.ok) {
    yield put(BusinessActions.enterpriseCustomersSuccess(response.data));
  } else {
    yield put(BusinessActions.enterpriseCustomersFailure(response.data));
  }
}

export function* enterpriseCustomersListCount(action) {
  const { businessId } = action;
  // if success
  const response = yield call(api.getEnterpriseCustomersCount, businessId)
  if (response.ok) {
    yield put(BusinessActions.enterpriseCustomersCountSuccess(response.data));
  } else {
    yield put(BusinessActions.enterpriseCustomersCountFailure(response.data));
  }
}

export function* searchBusinessCustomersSummary(action) {
  const { businessId, params } = action;
  const response = yield call(api.searchBusinessCustomersSummary, businessId, params);
  if (response.ok) {
    yield put(BusinessActions.businessCustomersSearchSummarySuccess(response.data));
  } else {
    yield put(BusinessActions.businessCustomersSearchSummaryFailure(response.data));
  }
}

export function* getVerifiedBusinessesDetail(action) {
  const { businessId } = action;
  //if success
  const response = yield call(api.approvedVerificationDetail, businessId)
  if (response.ok) {
    yield put(BusinessActions.approvedBusinessesDetailSuccess(response.data));
  } else {
    yield put(BusinessActions.approvedBusinessesDetailFailure(response.data));
  }
}


export function* enableCardPayments(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.enableCardPayments, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.enableCardPaymentsSuccess(response.data));
  } else {
    yield put(BusinessActions.enableCardPaymentsFailure(response.data));
  }
}

export function* overrideCardFees(action) {
  const { businessId, fees } = action;
  // make the call to the api
  const response = yield call(api.overrideCardFees, businessId, fees);
  // success?
  if (response.ok) {
    yield put(BusinessActions.overrideCardFeesSuccess(response.data));
  } else {
    yield put(BusinessActions.overrideCardFeesFailure(response.data));
  }
}

export function* overrideMomoFees(action) {
  const { businessId, fees } = action;
  // make the call to the api
  const response = yield call(api.overrideMomoFees, businessId, fees);
  // success?
  if (response.ok) {
    yield put(BusinessActions.overrideMomoFeesSuccess(response.data));
  } else {
    yield put(BusinessActions.overrideMomoFeesFailure(response.data));
  }
}

export function* passingFeesOn(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.passingFeesOn, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.passingFeesOnSuccess(response.data));
  } else {
    yield put(BusinessActions.passingFeesOnFailure(response.data));
  }
}

export function* verificationStartedRequest(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.verificationStartedRequest, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.verificationStartedSuccess(response.data));
  } else {
    yield put(BusinessActions.verificationStartedFailure(response.data));
  }
}
export function* businessVerificationRequest(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.businessVerificationRequest, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.businessVerificationSuccess(response.data));
  } else {
    yield put(BusinessActions.businessVerificationFailure(response.data));
  }
}

export function* invitationUptakeRequest(action) {
  const { businessId, planId, query, options } = action;
  // make the call to the api
  const response = yield call(api.getInvitationUptake, businessId, planId, query, options);
  // success?
  if (response.ok) {
    yield put(BusinessActions.invitationUptakeSuccess(response.data));
  } else {
    yield put(BusinessActions.invitationUptakeFailure(response.data));
  }
}

export function* segmentRequest(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getSegment, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.segmentSuccess(response.data));
  } else {
    yield put(BusinessActions.segmentFailure(response.data));
  }
}

export function* tagRequest(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getTagGroups, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.tagSuccess(response.data));
  } else {
    yield put(BusinessActions.tagFailure(response.data));
  }
}

export function* associateSegmentWithBusinessCustomer(action) {
  const { segmentId, bcId, businessId, refreshParams } = action;
  const response = yield call(api.associateSegmentWithBusinessCustomer, segmentId, bcId);
  if (response.ok) {
    yield put(BusinessActions.associateSegmentWithBusinessCustomerSuccess(response.data));
    if (businessId && refreshParams) {
      yield put(
        BusinessActions.businessCustomersSearchSummaryRequest(businessId, refreshParams)
      );
    }
  } else {
    yield put(BusinessActions.associateSegmentWithBusinessCustomerFailure(response.data));
  }
}

export function* associateTagWithBusinessCustomer(action) {
  const { tagId, bcId, businessId, refreshParams } = action;
  const response = yield call(api.associateTagWithBusinessCustomer, tagId, bcId);
  if (response.ok) {
    yield put(BusinessActions.associateTagWithBusinessCustomerSuccess(response.data));
    if (businessId && refreshParams) {
      yield put(
        BusinessActions.businessCustomersSearchSummaryRequest(businessId, refreshParams)
      );
    }
  } else {
    yield put(BusinessActions.associateTagWithBusinessCustomerFailure(response.data));
  }
}

export function* dissociateTagFromBusinessCustomer(action) {
  const { tagId, bcId, businessId, refreshParams } = action;
  const response = yield call(api.dissociateTagFromBusinessCustomer, tagId, bcId);
  if (response.ok) {
    yield put(BusinessActions.dissociateTagFromBusinessCustomerSuccess(response.data));
    if (businessId && refreshParams) {
      yield put(
        BusinessActions.businessCustomersSearchSummaryRequest(businessId, refreshParams)
      );
    }
  } else {
    yield put(BusinessActions.dissociateTagFromBusinessCustomerFailure(response.data));
  }
}

export function* linkPlanWithBusinessCustomer(action) {
  const { planId, bcId, businessId, refreshParams } = action;
  const response = yield call(api.linkPlanWithBusinessCustomer, bcId, planId);
  if (response.ok) {
    yield put(BusinessActions.linkPlanWithBusinessCustomerSuccess(response.data));
    if (businessId && refreshParams) {
      yield put(
        BusinessActions.businessCustomersSearchSummaryRequest(businessId, refreshParams)
      );
    }
  } else {
    yield put(BusinessActions.linkPlanWithBusinessCustomerFailure(response.data));
  }
}

export function* reportConfigurationsRequest(action) {
  const { businessId } = action;
  const response = yield call(api.getReportConfigurations, businessId);
  if (response.ok) {
    yield put(
      BusinessActions.reportConfigurationsSuccess(
        normalizeReportConfigurations(response.data)
      )
    );
  } else {
    yield put(BusinessActions.reportConfigurationsFailure(response.data));
  }
}

export function* createReportConfiguration(action) {
  const { businessId, reportConfiguration } = action;
  const response = yield call(api.createReportConfiguration, reportConfiguration);
  if (response.ok) {
    yield put(BusinessActions.createReportConfigurationSuccess(response.data));
    yield put(BusinessActions.reportConfigurationsRequest(businessId));
  } else {
    yield put(BusinessActions.createReportConfigurationFailure(response.data));
  }
}

export function* generateReportConfiguration(action) {
  const { configId, configName } = action;
  try {
    const response = yield call(api.generateReportConfigurationXlsx, configId);
    if (response.ok && hasReportConfigurationXlsxPayload(response.data)) {
      triggerReportConfigurationXlsxDownload(response.data, {
        filename: resolveReportDownloadFilename(response.headers),
        configName,
        configId,
      });
      yield put(BusinessActions.generateReportConfigurationSuccess());
    } else {
      const message =
        parseReportGenerateError(response) || "GENERATE_FAILED";
      yield put(BusinessActions.generateReportConfigurationFailure(message));
    }
  } catch {
    yield put(BusinessActions.generateReportConfigurationFailure("GENERATE_FAILED"));
  }
}

export function* deleteReportConfiguration(action) {
  const { configId, businessId } = action;
  const response = yield call(api.deleteReportConfiguration, configId);
  if (response.ok) {
    yield put(BusinessActions.deleteReportConfigurationSuccess());
    yield put(BusinessActions.reportConfigurationsRequest(businessId));
  } else {
    yield put(BusinessActions.deleteReportConfigurationFailure(response.data));
  }
}

export function* enableCustomPSP(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.enableCustomPSP, businessId);
  // success?
  if (response.ok) {
    yield put(BusinessActions.enableCustomPSPSuccess(response.data));
  } else {
    yield put(BusinessActions.enableCustomPSPFailure(response.data));
  }
}

export function* toggleReqsEnabled(action) {
  const { businessId } = action;
  const response = yield call(api.toggleReqsEnabled, businessId);
  if (response.ok) {
    yield put(BusinessActions.toggleReqsEnabledSuccess(response.data));
  } else {
    yield put(BusinessActions.toggleReqsEnabledFailure(response.data));
  }
}

export function* createSignupReqs(action) {
  const { businessId, tagGroupIds } = action;
  const response = yield call(api.createSignupReqs, businessId, tagGroupIds);
  if (response.ok) {
    yield put(BusinessActions.createSignupReqsSuccess(response.data));
  } else {
    yield put(BusinessActions.createSignupReqsFailure(response.data));
  }
}
export function* fetchSignupReqs(action) {
  const { businessId } = action;
  const response = yield call(api.getSignupReqs, businessId);
  if (response.ok) {
    yield put(BusinessActions.fetchSignupReqsSuccess(response.data));
  } else {
    yield put(BusinessActions.fetchSignupReqsFailure(response.data));
  }
}

export function* deleteSignupReq(action) {
  const { businessId, signupReqId } = action;
  const response = yield call(api.deleteSignupReq, businessId, signupReqId);
  if (response.ok) {
    yield put(BusinessActions.deleteSignupReqSuccess(response.data));
  } else {
    yield put(BusinessActions.deleteSignupReqFailure(response.data));
  }
}

export function* fetchSignupReqExclusions(action) {
  const { businessId } = action;
  const response = yield call(api.getSignupReqExclusions, businessId);
  if (response.ok) {
    yield put(BusinessActions.fetchSignupReqExclusionsSuccess(response.data));
  } else {
    yield put(BusinessActions.fetchSignupReqExclusionsFailure(response.data));
  }
}

export function* createSignupReqExclusions(action) {
  const { businessId, planGroupIds } = action;
  const response = yield call(api.createSignupReqExclusions, businessId, planGroupIds);
  if (response.ok) {
    yield put(BusinessActions.createSignupReqExclusionsSuccess(response.data));
  } else {
    yield put(BusinessActions.createSignupReqExclusionsFailure(response.data));
  }
}

export function* deleteSignupReqExclusion(action) {
  const { businessId, exclusionId } = action;
  const response = yield call(api.deleteSignupReqExclusion, businessId, exclusionId);
  if (response.ok) {
    yield put(BusinessActions.deleteSignupReqExclusionSuccess(response.data));
  } else {
    yield put(BusinessActions.deleteSignupReqExclusionFailure(response.data));
  }
}
export function* createSegment(action) {
  const { segment } = action;

  const response = yield call(api.createSegment, segment);

  if (response.ok) {
    yield put(BusinessActions.createSegmentSuccess(response.data))
  } else {
    yield put(BusinessActions.createSegmentFailure(response.data))
  }
}

export function* createTag(action) {
  const { tag } = action;

  const response = yield call(api.createTag, tag);

  if (response.ok) {
    yield put(BusinessActions.createTagSuccess(response.data))
  } else {
    yield put(BusinessActions.createTagFailure({ ...response.data, status: response.status }))
  }
}

export function* createTagGroup(action) {
  const { tagGroup } = action;
  // make the call to the api
  const response = yield call(api.createTagGroup, tagGroup);
  //success?
  if (response.ok) {
    yield put(BusinessActions.createTagGroupSuccess(response.data))
  } else {
    yield put(BusinessActions.createTagGroupFailure({ ...response.data, status: response.status }))
  }
}

export function* updateTagGroup(action) {
  const { groupId, tagGroup } = action;
  // make the call to the api
  const response = yield call(api.updateTagGroup, groupId, tagGroup);
  //success?
  if (response.ok) {
    yield put(BusinessActions.updateTagGroupSuccess(response.data))
  } else {
    yield put(BusinessActions.updateTagGroupFailure(response.data))
  }
}

export function* getTagGroups(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getTagGroups, businessId);
  //success?
  if (response.ok) {
    yield put(BusinessActions.tagGroupSuccess(response.data))
  } else {
    yield put(BusinessActions.tagGroupFailure(response.data))
  }
}

export function* updateTag(action) {
  const { tagId, tag } = action;
  // make the call to the api
  const response = yield call(api.updateTag, tagId, tag);
  //success?
  if (response.ok) {
    yield put(BusinessActions.updateTagSuccess(response.data))
  } else {
    yield put(BusinessActions.updateTagFailure(response.data))
  }
}

export function* getTagGroupsGraphed(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getTagGroupsGraphed, businessId);
  //success?
  if (response.ok) {
    yield put(BusinessActions.tagGroupGraphedSuccess(response.data))
  } else {
    yield put(BusinessActions.tagGroupGraphedFailure(response.data))
  }
}

export function* getTags(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getTags, businessId);
  //success?
  if (response.ok) {
    yield put(BusinessActions.tagsSuccess(response.data))
  } else {
    yield put(BusinessActions.tagsFailure(response.data))
  }
}